import {
  CircularProgress,
  LinearProgress,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

/** Page title (guide 7.3): text on the canvas, sentence case, icon muted. */
export const TitleTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[3],
  flex: '1',
  '& span': { fontSize: '24px', color: theme.palette.text.secondary },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[3],
  '& span': { fontSize: '22px', color: theme.palette.text.secondary },
}));

export const DialogTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[2],
  margin: `4px 0 ${theme.palette.tokens.space[5]}px`,
  '& span': { fontSize: '22px', color: theme.palette.text.secondary },
}));

export const WhiteCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const ColoredCircularProgress = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.tokens.color.action,
  })
);

/* The theme paints the track and the bar. */
export const StyledLinearProgress = styled(LinearProgress)(() => ({}));

/*
 * Every text field in the app goes through this object. The theme now paints
 * the outline, radius, focus ring and label, so only the width is left here;
 * the name stays because 30+ files import it.
 */
export const textFieldDefaultStyle = {
  width: '100%',
};

export const StyledTextField = styled(TextField)(() => textFieldDefaultStyle);

/* Menu items are painted by the theme (hover, selected, disabled). */
export const menuItemDefaultStyle = {};

/** Label of a read-only label/value pair (guide 7.8). */
export const InputTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  paddingBottom: '4px',
}));

/** Value of a read-only label/value pair: medium weight, no underline. */
export const SmallStyledInput = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.palette.tokens.font.weightMedium,
  color: theme.palette.text.primary,
  inlineSize: 'fit-content',
  minWidth: '100px',
  minHeight: '24px',
  overflowWrap: 'anywhere',
}));

export const AlertTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));
